import { render, staticRenderFns } from "./NotificationRecurringOrderProductNotEnoughStock.vue?vue&type=template&id=d8fbd76a&"
import script from "./NotificationRecurringOrderProductNotEnoughStock.vue?vue&type=script&lang=js&"
export * from "./NotificationRecurringOrderProductNotEnoughStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports